<template>
    <div v-if="showConsent" class="cookies-consent">
      <div class="cookies-content container">
        <div class="left">
            <div>{{$t('cookiesConsent.title')}}</div>
            <section>
                <p>{{$t('cookiesConsent.content')}} <a :href="cookiesHref"  target="_blank">{{$t('cookiesConsent.cookiesPolicy')}}</a>{{$t('cookiesConsent.content2')}}</p>
            </section>
            
        </div>
        
        <div class="cookies-buttons">
          <button @click="rejectCookies">{{$t('cookiesConsent.refuse')}}</button>
          <button @click="acceptCookies">{{$t('cookiesConsent.agree')}}</button>
        </div>
      </div>
    </div>
  </template>
  
  <script >
  import api from '@/api/api'
  export default{
    data(){
        return{
            showConsent: false,
            cookiesHref: ''
        }
    },
    created(){
        api.getCookiesPolicyApi({
				language: localStorage.langT,
				positionType: 5
			}).then(res => {
                if(res.code === 200){
                    this.cookiesHref = res.result[0].h5Link
                }
        })
       
    },
    mounted() {
        // 如果没有做出选择，显示弹窗
        if (!this.checkConsent()) {
            this.showConsent = true;
        }
    },
    methods: {
        // 检查是否已经做出选择
        checkConsent() {
            return localStorage.getItem('cookiesConsent');
        },
         // 接受cookies
        acceptCookies() {
            localStorage.setItem('cookiesConsent', 'accepted');
            this.showConsent = false;
            
            // 启用 GA
            if (window.gtag) {
                window.gtag('consent', 'update', {
                'analytics_storage': 'granted',
                'ad_storage': 'granted'
                });
            }
        },
        // 拒绝cookies
        rejectCookies() {
            localStorage.setItem('cookiesConsent', 'rejected');
            this.showConsent = false;
            // 移除或禁用非必要cookies  禁止设置非必要cookies
            this.removeNonEssentiaCookies();
        },
        removeNonEssentiaCookies() {
            // 移除cookies
            Cookies.remove('sidebarStatus');
            // 移除GA收集信息工具
            if (window.gtag) {
                window.gtag('consent', 'update', {
                    'analytics_storage': 'denied',
                    'ad_storage': 'denied'
                });

                ['_ga', '_gid', '_gat'].forEach(cookie => {
                    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                });
            }

        },
    }
  }
  
  </script>
  
  <style scoped>
  .cookies-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #212121;
    color: white;
    padding: 1.875rem 0;
    z-index: 9999;
  }
  
  .cookies-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .cookies-content .left {
    display: flex;
    align-items: center;
  }
  .cookies-content .left div{
    margin-right: 1.875rem;
    font-size: 1rem;
    font-weight: 500;
  }
  .cookies-content p {
    max-width: 594px;
    margin: 0;
    font-size: 0.875rem;
  }
  .cookies-content a{
    color: #fff;
    text-decoration: underline!important;
  }
  
  .cookies-buttons {
    display: flex;
    gap: 0.625rem;
  }
  
  .cookies-buttons button {
    padding: 0.625rem 1.25rem;
    border: none;
    background: transparent;
    border-radius: 1.9375rem;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .cookies-buttons button:first-child {
    color: rgba(255,255,255,.8);
  }
  
  .cookies-buttons button:last-child {
    border: solid 1px #fff;
    color: #fff;
  }
  </style>